import type { Container, ExtendedBlock, Graph, GraphEdge, GraphNode, RepeatableContainer, TabbedContainer } from 'widget-components/integrations/CustomPage/types'

export function isNestableBlock(block: ExtendedBlock): block is ExtendedBlock<Container> | ExtendedBlock<RepeatableContainer> | ExtendedBlock<TabbedContainer> | ExtendedBlock<Graph> | ExtendedBlock<GraphNode> | ExtendedBlock<GraphEdge> {
    return ['CONTAINER', 'REPEATABLE_CONTAINER', 'TABBED_CONTAINER', 'GRAPH', 'GRAPH_NODE', 'GRAPH_EDGE'].includes(block.type)
}
